import React from 'react';
import PropTypes from 'prop-types';

const Addition = ({ fill = '', ...rest }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M7.95998 6.04237L7.95982 1.28708L7.95567 1.20198C7.89742 0.693845 7.48852 0.327264 7.00001 0.327262C6.50636 0.327261 6.09471 0.701412 6.04514 1.18948L6.04079 1.26414L6.0404 6.04205L1.28479 6.04249L1.19888 6.04673C0.726379 6.10135 0.375316 6.4576 0.329911 6.90471L0.325555 6.97937L0.325746 7.02873L0.32921 7.0882C0.383838 7.5607 0.740093 7.91176 1.1872 7.95717L1.26186 7.96153L6.04009 7.96162L6.04025 12.7176L6.04343 12.7921C6.09475 13.3032 6.50641 13.6774 7.00006 13.6774L7.07463 13.6742L7.15416 13.6631C7.62406 13.5793 7.95986 13.1852 7.95986 12.7176L7.95966 7.96195L12.7153 7.96215L12.7899 7.95896C13.3009 7.90765 13.6751 7.49599 13.6751 7.00234C13.6751 6.47225 13.2454 6.04253 12.7153 6.04253L7.95998 6.04237Z"
      fill={fill || 'white'}
    />
  </svg>
);

Addition.propTypes = {
  fill: PropTypes.string,
  className: PropTypes.string,
};

export default Addition;
